import { Circle, Hexagon, Square } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { applyRadius } from "@/hooks/use-radius-preset";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";

const radiusOptions = [
  {
    name: "Square",
    radius_key: "square",
    icon: <Square/>,
  },
  {
    name: "Rounded",
    radius_key: "rounded",
    icon: <Hexagon/>,
  },
  {
    name: "Full",
    radius_key: "full",
    icon: <Circle/>,
  },
];

export function RadiusToggle() {
  const [borderRadius, setBorderRadius] = useState("default");

  // Initialize from localStorage on component mount
  useEffect(() => {
    const savedRadius = localStorage.getItem("border_radius") || "default";
    setBorderRadius(savedRadius);

    applyRadius(savedRadius);
  }, []);

  // Get the current icon based on the selected radius
  const currentIcon = radiusOptions.find(item => item.radius_key === borderRadius)?.icon || <Square className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all" />;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="muted-ghost" size="icon-md">
          {currentIcon}
          <span className="sr-only">Toggle border radius</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Radius</DropdownMenuLabel>
        {radiusOptions.map((item) => (
          <DropdownMenuItem
            key={item.radius_key}
            onClick={() => {
              localStorage.setItem("border_radius", item.radius_key);
              setBorderRadius(item.radius_key);
              applyRadius(item.radius_key);
            }}
          >
            {item.icon}
            {item.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}